@if (shouldShowDemoExpiry) {
  <div class="bg-gray-800 text-white p-4 rounded-lg mb-4 flex items-center justify-center">
    <div class="flex items-center space-x-3">
      <div class="bg-yellow-500 rounded-full w-8 h-8 flex-shrink-0 flex items-center justify-center"
        style="box-shadow: 0 0 15px rgba(234, 179, 8, 0.6), 0 0 25px rgba(234, 179, 8, 0.4), 0 0 35px rgba(234, 179, 8, 0.2);">
        <mat-icon class="text-white">warning</mat-icon>
      </div>
      <div class="flex items-center">
        <div class="font-semibold text-white">
          {{ 'SCORMS_LIST.DEMO_EXPIRES' | translate:{date: (dateFinDemo | date:'yyyy-MM-dd')} }}
        </div>
      </div>
    </div>
  </div>
}
@if (isDemoLimitReached) {
  <div class="bg-gray-800 text-white p-4 rounded-lg mb-4 flex items-center justify-center">
    <div class="flex items-center space-x-3">
      <div class="bg-red-500 rounded-full w-8 h-8 flex-shrink-0 flex items-center justify-center"
        style="box-shadow: 0 0 15px rgba(239, 68, 68, 0.6), 0 0 25px rgba(239, 68, 68, 0.4), 0 0 35px rgba(239, 68, 68, 0.2);">
        <mat-icon class="text-white">block</mat-icon>
      </div>
      <div class="flex items-center">
        <div class="font-semibold text-white">
          {{ 'SCORMS_LIST.DEMO_LIMIT_REACHED' | translate:{count: DEMO_SCORM_LIMIT} }}
        </div>
      </div>
    </div>
  </div>
}
@if (shouldShowWarningOnly) {
  <div class="bg-gray-800 text-white p-4 rounded-lg mb-4 flex items-center justify-center">
    <div class="flex items-center space-x-3">
      <div class="bg-red-500 rounded-full w-8 h-8 flex-shrink-0 flex items-center justify-center"
        style="box-shadow: 0 0 15px rgba(239, 68, 68, 0.6), 0 0 25px rgba(239, 68, 68, 0.4), 0 0 35px rgba(239, 68, 68, 0.2);">
        <mat-icon class="text-white">close</mat-icon>
      </div>
      <div class="flex items-center">
        <div class="font-semibold text-white">
          {{ isDemoExpired ? ('SCORMS_LIST.DEMO_EXPIRED' | translate) : ('SCORMS_LIST.NOVOSTUDIO_NOT_INCLUDED' |
        translate) }} </div>
      </div>
    </div>
  </div>
}
@if (!shouldShowWarningOnly && !isDemoLimitReached) {
  @if (isLoading) {
    <div class="flex justify-center items-center min-h-[60vh]">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }
  @if (!isLoading) {
    <div>
      <div class="container mx-auto pt-4 px-4 pb-1">
        @if (!shouldShowNoVideosMessage) {
          <div class="mb-1 flex gap-2 items-start">
            <div class="flex gap-2 flex-wrap flex-1">
          <button type="button" (click)="onCategoryToggle(PRIORITE_CATEGORY_ID)" [ngClass]="{
            'bg-red-600 text-white': filteredCategoryId === PRIORITE_CATEGORY_ID,
            'bg-gray-200 text-gray-700': filteredCategoryId !== PRIORITE_CATEGORY_ID
          }"
                class="flex items-center px-4 py-2 text-sm font-medium rounded-lg focus:z-10 focus:ring-2 focus:ring-red-500 focus:outline-none transition-colors duration-200">
                <span>{{ 'SCORMS_LIST.PRIORITY_CATEGORY' | translate }}</span>
              </button>
          <button type="button" (click)="onCategoryToggle(null)" [ngClass]="{
          'bg-red-600 text-white': filteredCategoryId === null,
          'bg-gray-200 text-gray-700': filteredCategoryId !== null
        }"
                class="flex items-center px-4 py-2 text-sm font-medium rounded-lg focus:z-10 focus:ring-2 focus:ring-red-500 focus:outline-none transition-colors duration-200">
                <span>{{ 'SCORMS_LIST.ALL' | translate }}</span>
              </button>
              @if (inProgressScormPackages.length > 0) {
                <button type="button"
            (click)="onCategoryToggle(EN_COURS_CATEGORY_ID)" [ngClass]="{
          'bg-red-600 text-white': filteredCategoryId === EN_COURS_CATEGORY_ID,
          'bg-gray-200 text-gray-700': filteredCategoryId !== EN_COURS_CATEGORY_ID
        }"
                  class="flex items-center px-4 py-2 text-sm font-medium rounded-lg focus:z-10 focus:ring-2 focus:ring-red-500 focus:outline-none transition-colors duration-200">
                  <span>
                    {{ 'SCORMS_LIST.IN_PROGRESS_CATEGORY' | translate }}
                  </span>
                </button>
              }
              @for (cat of displayedCategories; track cat) {
            <button type="button" (click)="onCategoryToggle(cat.categorieId)" [ngClass]="{
            'bg-red-600 text-white': filteredCategoryId === cat.categorieId,
            'bg-gray-200 text-gray-700': filteredCategoryId !== cat.categorieId
          }"
                  class="flex items-center px-4 py-2 text-sm font-medium rounded-lg focus:z-10 focus:ring-2 focus:ring-red-500 focus:outline-none transition-colors duration-200">
                  @if (cat.icone) {
                    <mat-icon class="mr-1">{{ cat.icone }}</mat-icon>
                  }
                  <span>{{ getLocalizedCategoryName(cat.locales) }}</span>
                </button>
              }
            </div>
            @if (filteredCategoryId !== PRIORITE_CATEGORY_ID) {
              <div class="flex-shrink-0" style="width: 250px;">
                <input type="text" [(ngModel)]="searchTerm" placeholder="{{ 'SCORMS_LIST.SEARCH_PLACEHOLDER' | translate }}"
                  class="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500 text-sm" />
                </div>
              }
            </div>
          }
          @if (shouldShowPriorityAndAllContent && !shouldShowNoVideosMessage) {
            <div class="mb-1 space-y-2">
              @if (filteredCategoryId === PRIORITE_CATEGORY_ID && !hasPriorityContent) {
                <div
                  class="p-4 text-center text-gray-500">
                  {{ 'SCORMS_LIST.NO_PRIORITY_CONTENT' | translate }}
                </div>
              }
              @if (filteredCategoryId === null || hasPriorityContent) {
                @for (parcours of nonCompletedParcours; track parcours) {
                  <app-parcours-formation-card [parcours]="parcours"
                    [showDescriptionFn]="showDescription.bind(this)"
                    [estServiceStudio]="currentEntiteServiceStudio"
                  [estServiceStudioContenusPerso]="currentEntiteServiceStudioContenusPerso"></app-parcours-formation-card>
                }
                @if (completedParcours.length > 0) {
                  <div class="my-6">
                    <button
                      class="w-full flex items-center justify-between px-6 py-6 bg-gray-100 rounded-2xl font-bold text-lg text-gray-700 shadow-lg border-2 border-gray-300 focus:outline-none"
                      (click)="toggleCompletedCollapse()">
                      <span>{{ 'SCORMS_LIST.COMPLETED_LEARNING_PATHS' | translate }}</span>
                      <span>
                        @if (!showCompletedCollapse) {
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                          </svg>
                        }
                        @if (showCompletedCollapse) {
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                          </svg>
                        }
                      </span>
                    </button>
                    @if (showCompletedCollapse) {
                      <div class="mt-4 space-y-4">
                        @for (parcours of completedParcours; track parcours) {
                          <app-parcours-formation-card [parcours]="parcours"
                            [showDescriptionFn]="showDescription.bind(this)"
                            [estServiceStudio]="currentEntiteServiceStudio"
                          [estServiceStudioContenusPerso]="currentEntiteServiceStudioContenusPerso"></app-parcours-formation-card>
                        }
                      </div>
                    }
                  </div>
                }
                @if (filteredFormationsGroupes.length > 0) {
                  <div class="mt-4 space-y-4">
                    @for (formationGroupe of filteredFormationsGroupes; track formationGroupe) {
                      @if (isSupervisorTrainingGroup(formationGroupe)) {
                        <div>
                          <app-groupe-formation-card [formation]="formationGroupe"
                          [showDescriptionFn]="showDescription.bind(this)"></app-groupe-formation-card>
                        </div>
                      }
                      @if (isParticipantTrainingGroup(formationGroupe) && !isSupervisorTrainingGroup(formationGroupe)) {
                        <div>
                          <div
                            class="flex items-center justify-between px-6 py-6 h-8 bg-gray-100 rounded-2xl font-bold  text-gray-700 shadow-lg border-2 border-gray-300 focus:outline-none">
                            {{ 'SCORMS_LIST.MSG_GROUP_TRAINING' | translate }} : {{formationGroupe.titre }} {{ 'SCORMS_LIST.DATE'
                            |
                            translate }} {{formationGroupe.dateHeurePrevue | date: 'yyyy-MM-dd' }} {{ 'SCORMS_LIST.HEURE' |
                            translate
                            }}
                            {{formationGroupe.dateHeurePrevue | date: 'HH:mm'}} {{ 'SCORMS_LIST.PLACE' | translate }} :
                            {{formationGroupe.emplacement}}
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
        @if (shouldShowNoVideosMessage) {
          <div
            class="bg-gray-800 text-white p-4 rounded-lg mb-4 flex items-center justify-center">
            <div class="flex items-center space-x-3">
              <div class="bg-blue-500 rounded-full w-8 h-8 flex-shrink-0 flex items-center justify-center"
                style="box-shadow: 0 0 15px rgba(59, 130, 246, 0.6), 0 0 25px rgba(59, 130, 246, 0.4), 0 0 35px rgba(59, 130, 246, 0.2);">
                <mat-icon class="text-white">info</mat-icon>
              </div>
              <div class="flex items-center">
                <div class="font-semibold text-white">
                  {{ 'SCORMS_LIST.NO_VIDEOS_AVAILABLE' | translate }}
                </div>
              </div>
            </div>
          </div>
        }
        <div class="container p-1 mx-auto">
          @if (filteredCategoryId === null) {
            @for (section of allSections; track section.title) {
              @if (section.packages.length > 0) {
                <div>
                  <div class="flex items-center mb-1" style="height: 2.5rem;">
                    <h3 class="text-lg font-bold whitespace-nowrap mr-4 flex-shrink-0 flex items-center"
                      style="line-height: 1;">
                      @if (section.icon) {
                        <mat-icon class="mr-1">{{ section.icon }}</mat-icon>
                      }
                      @if (section.categorieIcon) {
                        <mat-icon class="mr-1">{{ section.categorieIcon }}</mat-icon>
                      }
                      {{ section.title }}
                    </h3>
                    <hr class="flex-grow border-t border-gray-300" style="margin-top: 0.5em; margin-bottom: 0.5em;">
                  </div>
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                    @for (scormPackage of section.packages; track scormPackage) {
                      <app-scorm-package-card [scormPackage]="scormPackage"
                        [getLocalizedContent]="getLocalizedContent.bind(this)" [showDescription]="showDescription.bind(this)"
                        [shouldShowProgressionIcon]="shouldShowProgressionIcon.bind(this)">
                      </app-scorm-package-card>
                    }
                  </div>
                </div>
              }
            }
          }
          @if (filteredCategoryId === EN_COURS_CATEGORY_ID && filterPackagesByCategoryWithSearch(EN_COURS_CATEGORY_ID).length > 0) {
            <div class="flex items-center mb-1" style="height: 2.5rem;">
              <h3 class="text-lg font-bold whitespace-nowrap mr-4 flex-shrink-0 flex items-center" style="line-height: 1;">
                {{ 'SCORMS_LIST.IN_PROGRESS_CATEGORY' | translate }}
              </h3>
              <hr class="flex-grow border-t border-gray-300" style="margin-top: 0.5em; margin-bottom: 0.5em;">
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
              @for (scormPackage of filterPackagesByCategoryWithSearch(EN_COURS_CATEGORY_ID); track scormPackage) {
                <app-scorm-package-card [scormPackage]="scormPackage"
                  [getLocalizedContent]="getLocalizedContent.bind(this)" [showDescription]="showDescription.bind(this)"
                  [shouldShowProgressionIcon]="shouldShowProgressionIcon.bind(this)">
                </app-scorm-package-card>
              }
            </div>
          }
          @for (cat of displayedCategories; track cat) {
            @if (filterPackagesByCategoryWithSearch(cat.categorieId).length > 0 && filteredCategoryId === cat.categorieId) {
              <div>
                <div class="flex items-center mb-1" style="height: 2.5rem;">
                  <h3 class="text-lg font-bold whitespace-nowrap mr-4 flex-shrink-0 flex items-center"
                    style="line-height: 1;">
                    @if (cat.categorieId === -1) {
                      <mat-icon class="mr-1">play_arrow</mat-icon>
                    }
                    @if (cat.icone) {
                      <mat-icon class="mr-1">{{ cat.icone }}</mat-icon>
                    }
                    {{ getLocalizedCategoryName(cat.locales) }}
                  </h3>
                  <hr class="flex-grow border-t border-gray-300" style="margin-top: 0.5em; margin-bottom: 0.5em;">
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                  @for (scormPackage of filterPackagesByCategoryWithSearch(cat.categorieId); track scormPackage) {
                    <app-scorm-package-card
                      [scormPackage]="scormPackage" [getLocalizedContent]="getLocalizedContent.bind(this)"
                      [showDescription]="showDescription.bind(this)"
                      [shouldShowProgressionIcon]="shouldShowProgressionIcon.bind(this)">
                    </app-scorm-package-card>
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  }
